import React from "react";
import Navbar from "./Navbar/NavBar";
import {Button, Card, Col, Form, Input, Layout, Modal, Row} from "antd";
import {sendQueries} from "./Util";

function BugReports() {
    const formItemLayout = {
        labelCol: {xs: {span: 24}, sm: {span: 6}},
        wrapperCol: {xs: {span: 24}, sm: {span: 18}},
    };

    const [form] = Form.useForm();
    const onFinish = async (values) => {
        const response = await sendQueries(JSON.stringify(values))
        if (response.isSuccess) {
            Modal.success({
                title: 'Thank you !!',
                content: 'We have received your request.',
            });
            form.resetFields(["email", "message"])
        } else {
            Modal.error({
                title: 'Sorry !!',
                content: response.data,
            });
        }
    }
    const onFinishFailed = (errorInfo) => {
        Modal.error({
            title: 'Sorry !!',
            content: 'Failed to send your request. Please try again later.',
        });
    };
    return (
        <Layout style={{backgroundColor: '#FFFFFF', minHeight: '100dvh'}}>
            <div style={{position: 'sticky', top: 0, zIndex: 10000}}>
                <Navbar/>
            </div>
            <Layout.Content style={{display: "flex", flexDirection: "column", backgroundColor: '#FFFFFF', gap: 40}}>
                <Row style={{justifyContent: "center"}}>
                    <Col style={{marginTop: '10vh', marginLeft: '3vh'}} span={10}>
                        <Card title={"Please use this form to report any bugs, queries or submit feature requests."}>
                            <Form
                                form={form}
                                {...formItemLayout}
                                variant="filled"
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                style={{maxWidth: 600}}>
                                <Form.Item
                                    label="Sender's email"
                                    name="email"
                                    rules={[{
                                        required: true,
                                        message: 'Please provide your email address to get back',
                                        type: 'email'
                                    }]}>
                                    <Input style={{width: '100%'}}/>
                                </Form.Item>

                                <Form.Item
                                    label="Request message"
                                    name="message"
                                    rules={[{required: true, message: 'Please provide your message here'}]}>
                                    <Input.TextArea style={{width: '100%', height: '20dvh'}}/>
                                </Form.Item>
                                <Form.Item wrapperCol={{offset: 4, span: 12}}>
                                    <Button type="primary" htmlType="submit">Send</Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Layout.Content>
            <Layout.Footer style={{width: '100%', textAlign: 'right', zIndex: 1000, backgroundColor: "#58B2DC"}}><b>About
                <a href="https://lcb.infotech.monash.edu/phisical/" target="_blank" rel="noreferrer"
                   style={{color: "#1402f6"}}> 𝜙𝛹𝜒al</a> |
                <a href="https://lcb.infotech.monash.edu/" target="_blank" rel="noreferrer"
                   style={{color: "#1402f6"}}> LCB Home</a> |v1.0.0 </b>
            </Layout.Footer>
        </Layout>
    )
}

export default BugReports;